<template>
  <v-expansion-panels v-model="panelOpen">
    <v-expansion-panel class="va-expandable-wrapper" readonly>
      <v-expansion-panel-header>
        <div class="d-flex flex-column">
          <div class="va-expandable-wrapper--title">{{ title }}</div>
          <div class="va-expandable-wrapper--subtitle">{{ subTitle }}</div>
        </div>
        <template #actions>
          <v-btn @click="toggleExpansionPanel" class="va-expandable-wrapper--btn" outlined :color="'primary'">
            <template v-if="isExpanded">
              {{ $t("generic.collapse") }}
              <v-icon size="16">mdi-chevron-down</v-icon>
            </template>
            <template v-else>
              {{ $t("generic.open") }}
              <v-icon size="16">mdi-chevron-up</v-icon>
            </template>
          </v-btn>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <slot></slot>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  export default {
    name: "VaExpandableInput",
    props: {
      open: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: "",
      },
      subTitle: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        // Determines WHICH panel is expanded (opened). Works by index, that's why first panel is 0.
        panelOpen: null,
      };
    },
    computed: {
      // Determines if the expansion panel is expanded or not
      isExpanded() {
        return this.panelOpen === 0 ? true : false;
      },
    },
    watch: {
      open: {
        handler(val) {
          this.panelOpen = val ? 0 : null;
        },
        immediate: true,
      },
    },
    methods: {
      toggleExpansionPanel() {
        this.panelOpen = this.isExpanded ? null : 0;
      },
      emitValue(val) {
        /**
         * Expansion panels work by index, that's why setting the value to 0 opens the panel.
         */
        this.panelOpen = val ? 0 : false;
        this.$emit("input", !!val);
        this.$emit("change", !!val);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/functions.scss";
  @import "../../@core/preset/preset/typography/index.scss";
  .va-expandable-wrapper {
    background-color: get-color("element-bg-100") !important;
    border-radius: 6px;
    box-shadow: 0px 2px 10px rgba(69, 64, 78, 0.1);
    &--title {
      @include heading-3();
      color: get-color("headline");
      margin-bottom: 6px;
    }
    &--subtitle {
      @include text-subtitle-1();
      color: get-color("subtitle");
    }
    &--switch {
      margin-top: 0;
      padding: 0;
    }
    &--btn {
      padding: 12px 16px 12px 24px !important;
      &::v-deep {
        .v-icon {
          color: get-color("secondary-btn") !important;
          margin-left: 6px;
          transform: rotate(180deg);
        }
      }
    }
    &::before {
      box-shadow: none !important;
    }
    &::v-deep {
      .v-expansion-panel-header {
        padding: 16px;
        cursor: default;
      }
      .v-expansion-panel-header__icon {
        align-self: center;
        margin: 0;
        .v-input--selection-controls__input {
          margin-right: 0;
        }
      }
    }
  }

  .v-application.theme--light .v-expansion-panel.v-expansion-panel--active {
    box-shadow: none !important;
  }
</style>
